import { CallState, LoadingState } from '@lcs/shared/api';
import { createReducer, on } from '@ngrx/store';
import { onReset } from 'src/app/authentication/reset-reducer';
import { ExtensionGroupOption } from '../../extension-groups-register/models/extension-group-option.interface';
import { ExtensionOption } from '../../extension-register/models/extension-option.interface';
import { PrivilegeView } from '../models/role-detail-view.model';
import { GetRoleDetail_role } from '../queries/generated/GetRoleDetail';
import * as RoleDetailActions from './role-detail.actions';

export const roleDetailFeatureKey = 'roleDetail';

export interface State {
   role: GetRoleDetail_role | null;
   privileges: PrivilegeView[] | null;
   extensions: ExtensionOption[];
   extensionGroups: ExtensionGroupOption[];
   callState: CallState;
}

export const initialState: State = {
   callState: LoadingState.Init,
   role: null,
   privileges: null,
   extensions: [],
   extensionGroups: [],
};

export const reducer = createReducer(
   initialState,
   onReset(initialState),
   on(
      RoleDetailActions.roleDetailLoad,
      RoleDetailActions.roleDetailCancel,
      RoleDetailActions.privilegesLoad,
      (state) => {
         return {
            ...state,
            callState: LoadingState.Loading,
            role: null,
            privileges: null,
         };
      }
   ),
   on(RoleDetailActions.loadRoleDetailsSuccess, RoleDetailActions.loadSystemRoleDetailsSuccess, (state, action) => {
      const role: GetRoleDetail_role = action.data;
      const extensions = action.extensions.items;
      const extensionGroups = action.extensionGroups.items;
      return {
         ...state,
         callState: LoadingState.Loaded,
         role: role,
         extensions: extensions,
         extensionGroups: extensionGroups,
      };
   }),
   on(RoleDetailActions.loadRoleDetailsFailure, (state, action) => {
      return {
         ...state,
         callState: action,
      };
   }),
   on(RoleDetailActions.saveRoleDetailSuccess, (state) => {
      return {
         ...state,
         callState: LoadingState.Loading,
      };
   }),
   on(
      RoleDetailActions.saveRoleDetailFailure,
      RoleDetailActions.roleDetailAccessDenied,
      RoleDetailActions.privilegesLoadFailure,
      (state) => {
         return {
            ...state,
            callState: LoadingState.Loaded,
         };
      }
   ),
   on(RoleDetailActions.privilegesLoadSuccess, (state, action) => {
      return {
         ...state,
         callState: LoadingState.Loaded,
         privileges: action.data,
      };
   })
);
